import { InventoryOwnerType } from "@1games-ru/region-shared/dist/enums/inventory/inventory";
import { useCallback } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { OwnerType } from "@/domains/inventory/constants/ownerType";
import { deleteInventory, inventoryByIdSelector } from "@/domains/inventory/slice";
import { playerInfoSelector } from "@/domains/player/slice";
import useInventoryManager from "@/domains/inventory/hooks/inventory/useInventoryManager";
import useFilterItems from "@/domains/inventory/hooks/useFilterItems";
import useGetInventory from "@/domains/inventory/hooks/useGetInventory";
import useSearchItems from "@/domains/inventory/hooks/useSearchItems";
import InventoryCommonHeader from "@/domains/inventory/components/InventoryCommonHeader";
import InventoryContent from "@/domains/inventory/components/InventoryContent";
import InventoryFilter from "@/domains/inventory/components/InventoryFilter";
import InventoryFooter from "@/domains/inventory/components/InventoryFooter";
import InventoryHeader from "@/domains/inventory/components/InventoryHeader";
import InventorySearch from "@/domains/inventory/components/InventorySearch";
import InventoryWeight from "@/domains/inventory/components/InventoryWeight";
import InventoryWrapper from "@/domains/inventory/components/InventoryWrapper";
import InventoryList from "@/domains/inventory/components/dndkit/InventoryList";

type Props = { inventoryId: number };

export default function InventoryCharacterEnvironmentContainer({ inventoryId }: Props) {
  const dispatch = useAppDispatch();
  const inventory = useAppSelector((state) => inventoryByIdSelector(state, inventoryId));
  const { filteredItems, filterGroups, selectedGroups, onSelectHandler } = useFilterItems(
    inventory?.items || [],
  );
  const { onChangeSearchValue, deferredSearchValue, itemsBySearch } = useSearchItems(filteredItems);
  const playerInfo = useAppSelector(playerInfoSelector);
  const { getInventory } = useGetInventory();
  const { dropItem, pickItem } = useInventoryManager();

  const onClose = useCallback(() => {
    dispatch(deleteInventory(inventoryId));
  }, [inventoryId]);

  const onRefresh = useCallback(() => {
    if (playerInfo) {
      getInventory({
        inventoryOwnerId: String(playerInfo.character.id),
        inventoryOwnerType: InventoryOwnerType.Character,
      });
    }
  }, [playerInfo]);

  if (!playerInfo) return null;
  if (inventory?.items && !inventory.items.length) return null;

  return (
    <InventoryWrapper className="max-h-full min-h-[20rem] w-[35rem]">
      <InventoryHeader className="px-0 border border-b-0 border-dark-900 rounded-t-[inherit] overflow-clip">
        <InventoryCommonHeader
          onClose={onClose}
          ownerType={OwnerType.Environment}
          iconClassName="text-white/50"
        />
      </InventoryHeader>
      <InventoryContent className="flex items-center justify-between w-full h-[3rem]">
        <InventorySearch
          value={deferredSearchValue}
          onChange={onChangeSearchValue}
          className="w-fit"
        />
        {filterGroups.length > 0 && (
          <InventoryFilter
            groups={filterGroups}
            selectedGroups={selectedGroups}
            onSelect={onSelectHandler}
          />
        )}
      </InventoryContent>
      <InventoryContent className="flex-1 overflow-clip overflow-y-auto flex flex-col pb-5">
        <InventoryList
          inventoryId={inventory.id}
          items={itemsBySearch}
          onRefresh={onRefresh}
          onPick={pickItem}
          onDrop={dropItem}
        />
      </InventoryContent>
      <InventoryFooter>
        <InventoryWeight weight={inventory.weight} />
        {/* <Button color="gray" variant="soft" className="h-[3rem] text-14 font-medium capitalize">
          {"Забрать все"}
        </Button> */}
      </InventoryFooter>
    </InventoryWrapper>
  );
}
